var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3223 1.25146C19.0124 1.25167 19.5723 1.81124 19.5723 2.50146V17.5015H20.1973C20.5423 17.5017 20.8223 17.7814 20.8223 18.1265C20.822 18.4713 20.5421 18.7513 20.1973 18.7515H1.44727C1.10224 18.7515 0.822519 18.4714 0.822266 18.1265C0.822266 17.7813 1.10209 17.5015 1.44727 17.5015H2.07227V13.7515C2.07227 13.0611 2.63191 12.5015 3.32227 12.5015H5.82227C6.51244 12.5017 7.07227 13.0612 7.07227 13.7515V17.5015H8.32227V8.75146C8.32227 8.06111 8.88191 7.50146 9.57227 7.50146H12.0723C12.7624 7.50167 13.3223 8.06124 13.3223 8.75146V17.5015H14.5723V2.50146C14.5723 1.81111 15.1319 1.25146 15.8223 1.25146H18.3223Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.23fee06e17c8749fcfd2a78f2b84cc6f.svg";
export { ForwardRef as ReactComponent };